type Props = {
    html: string;
};

export const RichText = ({ html }: Props) => (
    <div
        data-content-block="rich-text"
        className="prose max-w-none py-2 sm:mx-1
      [&_a]:underline
      [&_a]:text-blue-600
      [&_a:hover]:text-blue-800"
        dangerouslySetInnerHTML={{ __html: html }}
    />
);
